<template>
  <div class="wrapper-dashboard">
    <div class="ui container">
      <div v-if="loading" class="wrap-loding-chart">
        <t-placeholder :lines="3" />
      </div>
      <t-dashboard-kpi v-else :list-kpis="kpisList"  />
      <t-chart-payments-day />
      <t-chart-value-payments />
      <t-tables-dashboard />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  components: {
    TDashboardKpi: () => import('@/components/dashboard/kpi.vue'),
    TChartPaymentsDay: () => import('@/components/dashboard/chart-payments-day.vue'),
    TChartValuePayments: () => import('@/components/dashboard/chart-value-payments.vue'),
    TTablesDashboard: () => import('@/components/dashboard/tables-dashboard.vue'),
  },

  data () {
    return {
      loading: true,
      kpisList: null
    }
  },

  computed: {
    ...mapState({
      campaignId: ({ campaign }) => campaign.campaign.id,
      listCampaignData: ({ dashboard }) => dashboard.listCampaignData
    })
  },

   mounted () {
    this.getCampaignDataQuery({ id: this.campaignId })
    setTimeout(() => {
      if (this.listCampaignData.lenght > 0) {
        this.loading = true
      } else {
        this.loading = false
        this.listKPIs()
      }
    }, 1500)
  },

  methods: {
    ...mapActions("dashboard", ["getCampaignDataQuery"]),

    listKPIs () {
      this.kpisList =  [
        {
          type: 'records',
          title: 'Conversão de cadastros',
          value: this.listCampaignData.paidCountPercentage,
          text: `${this.listCampaignData.peoplePaidCount} de ${this.listCampaignData.peopleRegisteredCount} cadastros`
        },
        {
          type: 'finace',
          title: `Conversão de receita ${this.listCampaignData.paidAmountPercentage}`,
          value: this.listCampaignData.paidAmountPercentage,
          text: `${this.listCampaignData.paidAmount} de ${this.listCampaignData.registeredAmount}`
        },
        {
          type: 'meta',
          title: 'Meta',
          value: this.listCampaignData.goalValuePercent,
          text: `meta de ${this.listCampaignData.goalValue}`
        },
        {
          type: 'default',
          title: 'Tícket médio',
          value: this.listCampaignData.averageAmount
        },
        {
          type: 'default',
          title: 'Valor recebido',
          value: this.listCampaignData.paidAmount
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.wrap-loding-chart {
  margin-bottom: 4rem;
}
</style>
